var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title"}],staticClass:"hello",attrs:{"data-title":"杰宜斯云服务"}},[_c('hhead'),_vm._v(" "),_c('msg'),_vm._v(" "),_c('nnav'),_vm._v(" "),_c('div',{staticStyle:{"position":"relative","margin-top":"195px"}},[_c('foot')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb52437","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = null
// module chunks = 